import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ddt from '@wix/da-ddt';
import { useAvailableSpace } from '@wix/da-hooks/pkg/useAvailableSpace';
import { MeasuredCookieType } from '../../Measured';
import { updateMeasuredCookie } from '../../Measured/redux/actions';
import { makeGetPrevLoadDims } from '../../Measured/redux/selectors';
const logger = ddt.createLogger('artstage');
export function useMeasuredStage(ref, shouldUpdateCookie = true, cookieType = MeasuredCookieType.DEVIATION_ARTSTAGE, cookieDim = 'both') {
    const dispatch = useDispatch();
    const getPrevLoadDims = useMemo(()=>makeGetPrevLoadDims(), []);
    const prevLoadDims = useSelector((state)=>getPrevLoadDims(state, cookieType, cookieDim));
    logger.log('Cookie dims', prevLoadDims);
    const onResize = useCallback(({ contentSize  })=>{
        if (contentSize && shouldUpdateCookie) {
            logger.log('Updating cookie', contentSize);
            dispatch(updateMeasuredCookie(cookieType, cookieDim, contentSize)); // only the contentSize is important to save
        }
    }, [
        cookieDim,
        cookieType,
        dispatch,
        shouldUpdateCookie
    ]);
    const sizes = useAvailableSpace(ref, onResize, {
        contentSize: {
            width: prevLoadDims.width || undefined,
            height: prevLoadDims.height || undefined
        }
    });
    return sizes;
}
